// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","423":"2e6bde05","678":"component---src-pages-index-js","883":"component---src-pages-404-js","976":"c16184b3"}[chunkId] + "-" + {"351":"eea1c5128d5eb413330e","423":"2efb10de15df1d999654","678":"2ace9131f998792f2302","883":"f467e2d274443e581349","976":"f88544c82e8975d8df9f"}[chunkId] + ".js";
};